import { render } from "./DealerList.vue?vue&type=template&id=a28dc3e6&scoped=true"
import script from "./DealerList.vue?vue&type=script&lang=js"
export * from "./DealerList.vue?vue&type=script&lang=js"

import "./DealerList.vue?vue&type=style&index=0&id=a28dc3e6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28dc3e6"]])

export default __exports__